import { OffersList } from '../OffersList';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

export const offersListComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'offersList',
  component: OffersList,
  tagName: 'offerslist',
  stylable: true,
  droppable: false,
  defaultAttributes: {
    url: '',
    oneLine: false,
    staticRegion: false,
    hideShowMoreButton: false,
  },
  traits: [
    {
      type: 'text',
      label: 'Url',
      name: 'url',
    },
    {
      type: 'checkbox',
      label: 'One line (desktop)',
      name: 'oneLine',
    },
    {
      type: 'checkbox',
      label: 'Static region',
      name: 'staticRegion',
    },
    {
      type: 'checkbox',
      label: 'Hide "Посмотреть ещё"',
      name: 'hideShowMoreButton',
    },
  ],
  block: {
    label: 'OffersList',
    category: 'Content',
    content: '<OffersList url="" />',
  },
};
